import FastClick from '../vendor/fastclick';

function init() {
  FastClick.attach(document.body);
}

export default {
  init,
};



// WEBPACK FOOTER //
// ./js/utilities/fastclick.js